import { Link } from "react-router-dom";

const Demo4Hero4 = () => {
  return (
    <section
      id="hero-4"
      className="bg-scroll hero-section division"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source
          src="https://www.cigbusinesssetup.ae/wp-content/uploads/2025/07/6006201_Person_People_1280x720.mp4"
          type="video/mp4"
        />
      </video>
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // background: "rgba(0, 0, 0, 0)",
          zIndex: 1,
        }}
      />
      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="row">
          {/* HERO TEXT */}
          <div className="col-md-8 col-lg-6">
            <div className="hero-txt white-color1">
              <span className="hero-txt__eyebrow">UAE business setup made simple</span>
              <h1 className="h2-md">
                <span>Start Your UAE Business<br />With Confidence</span>
              </h1>
              <p className="p-md">
                Compare business setup packages, choose the right free zone or freelance solution, and get expert support for licensing and visas.
              </p>
              <div className="hero-txt__actions">
                <Link to="/site/packages" className="hero-primary-action">
                  Customize Your Package
                </Link>
                <Link to="/packages" className="hero-secondary-action">
                  Explore Packages <span aria-hidden="true">&#8594;</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* End row */}
      </div>
      {/* End container */}
    </section>
  );
};

export default Demo4Hero4;
